module.exports = __webpack_public_path__ + "assets/embed-tag.f4205c3a.svg";